import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import $ from "jquery";
import React from 'react';
import { FormattedMessage, injectIntl, intlShape } from "react-intl";
import * as constants from "../../../util/constants";
import paymentTypes from "../../../util/paymentTypes";
import Alert from "../../common/Alert";
import ButtonSave from "../../common/ButtonSave";
import CardBrandIcon from "../../common/CardBrandIcon";
import FieldAddress from "../../common/FieldAddress";
import FieldCheckbox from "../../common/FieldCheckbox";
import FieldLocale from "../../common/FieldLocale";
import FieldPhones from "../../common/FieldPhones";
import FieldText from "../../common/FieldText";
import Modal from "../../common/Modal";
import Propertii from "../../common/Propertii";
import Table from "../../common/Table";

class BillingProfiles extends Propertii {

    /**
     * Initialize the component.
     *
     * @param props - The properties of the component.
     */
    constructor(props) {

        super(props);

        this.state = {

            billingProfile: {},
            address: {},
            phoneNumberList: [],

            paymentMethod: {},
            paymentMethodList: [],

            billingProfileList: {
                page: '',
                recordsPerPage: '',
                totalPages: '',
                totalRecordCount: '',
                records: [
                    {}
                ]
            },

            billingProfileQuery: {
                orderBy: 'ASC',
                orderByFields: ['createDate'],
                conditionList: [
                    {
                        type: 'STRING',
                        logicalOperator: 'AND',
                        openBrackets: null,
                        closeBrackets: null,
                        fieldName: 'rmCompanyId',
                        operator: 'EQUALS',
                        fieldValue: this.props.match.params.companyId
                    }
                ]
            },

            validationList: [],

        };

        this.searchBillingProfiles = this.searchBillingProfiles.bind(this);
        this.searchPaymentMethods = this.searchPaymentMethods.bind(this);

        this.editBillingProfile = this.editBillingProfile.bind(this);
        this.initBillingProfile = this.initBillingProfile.bind(this);
        this.saveBillingProfile = this.saveBillingProfile.bind(this);
        this.deleteBillingProfile = this.deleteBillingProfile.bind(this);

        this.handleChangePaymentMethod = this.handleChangePaymentMethod.bind(this);
    }

    /**
     * Initialize the list of billing profiles on mounting of the component.
     */
    componentDidMount() {

        this.searchBillingProfiles(1, 25, this.state.billingProfileQuery);
    }

    /**
     * Handle selecting a billing profile record by bringing up the modal with billing profile values pre-filled.
     *
     * @param billingProfileId - The ID of the billing profile selected.
     */
    editBillingProfile(billingProfileId) {

        let billingProfile = {};
        let paymentMethod = {};

        axios.get(`${constants.REACT_APP_HOST_BILLING_AND_INVOICING_URL}/billing/profile/${billingProfileId}`, {
            headers: this.generateRequestHeaders()
        }).then(response => {

            billingProfile = response.data;

            axios.get(`${constants.REACT_APP_HOST_API_URL}/${billingProfile.rmPaymentMethodType.substring(5).toLowerCase()}/${billingProfile.paymentMethodId}`, {
                headers: this.generateRequestHeaders()
            }).then(response => {

                paymentMethod = response.data;

                this.setState(prevState => ({
                    ...prevState,
                    billingProfile: billingProfile,
                    phoneNumberList: billingProfile.phoneNumberList,
                    paymentMethod: paymentMethod,
                    address: billingProfile.address
                }));

                this.searchPaymentMethods();

            }).catch(error => {
                this.handleValidation(error);
            });

            $('#billing-profile').modal('show');

        }).catch(error => {
            this.handleValidation(error);
        });
    }

    /**
     * Initialize a new instance of a billing profile object when the user clicks the 'create billing profile' button.
     */
    initBillingProfile() {

        axios.get(`${constants.REACT_APP_HOST_BILLING_AND_INVOICING_URL}/billing/profile/new`, {
            headers: this.generateRequestHeaders()
        }).then(response => {

            let billingProfile = response.data;

            billingProfile.rmCompanyId = this.props.match.params.companyId;

            this.setState(prevState => ({
                ...prevState,
                billingProfile: billingProfile,
            }));

            this.searchPaymentMethods();

        }).catch(error => {
            this.handleValidation(error);
        });
    }

    /**
     * Delete the selected billing profile.
     */
    deleteBillingProfile() {

        axios.delete(`${constants.REACT_APP_HOST_BILLING_AND_INVOICING_URL}/billing/profile/${this.state.billingProfile.id}`, {
            headers: this.generateRequestHeaders()
        }).then(response => {

            this.setState({
                validationList: [{
                    fields: {},
                    alert: {
                        type: 'primary',
                        code: 'admin.companies.billing.deleted'
                    }
                }],
            });

            this.searchBillingProfiles(this.state.billingProfileList.page, this.state.billingProfileList.recordsPerPage, this.state.billingProfileQuery);

            $('#billing-profile').modal('hide');

        }).catch(error => {
            this.handleValidation(error);
        });

        window.scrollTo(0, 0);
    }


    /**
     * Handle the submission of the form. Use the create date field of the billing profile in the state to determine if
     * the user is editing or creating a new billing profile. Upon successful submission of the form, refresh the table
     * and hide the modal.
     *
     * @param event - The event container.
     */
    saveBillingProfile(event) {

        event.preventDefault();

        let billingProfile = this.state.billingProfile;

        billingProfile.paymentMethodId = this.state.paymentMethod.id;
        billingProfile.rmPaymentMethodType = this.state.paymentMethod.type;
        billingProfile.phoneNumberList = this.state.phoneNumberList;
        billingProfile.address = this.state.address;

        if(this.state.billingProfile.createDate == null) {
            axios.post(`${constants.REACT_APP_HOST_BILLING_AND_INVOICING_URL}/billing/profile/create`, billingProfile, {
                headers: this.generateRequestHeaders()
            }).then(response => {

                this.setState({
                    validationList: [{
                        fields: {},
                        alert: {
                            type: 'primary',
                            code: 'admin.companies.billing.created'
                        }
                    }],
                });

                this.searchBillingProfiles(this.state.billingProfileList.page, this.state.billingProfileList.recordsPerPage, this.state.billingProfileQuery);

                $('#billing-profile').modal('hide');

            }).catch(error => {
                this.handleValidation(error);
            });
        } else {
            axios.put(`${constants.REACT_APP_HOST_BILLING_AND_INVOICING_URL}/billing/profile/${billingProfile.id}`, billingProfile, {
                headers: this.generateRequestHeaders()
            }).then(response => {

                this.setState({
                    validationList: [{
                        fields: {},
                        alert: {
                            type: 'primary',
                            code: 'saved',
                            message: 'Changes have been saved'
                        }
                    }],
                });

                this.searchBillingProfiles(this.state.billingProfileList.page, this.state.billingProfileList.recordsPerPage, this.state.billingProfileQuery);

                $('#billing-profile').modal('hide');

            }).catch(error => {
                this.handleValidation(error);
            });
        }

        window.scrollTo(0, 0);
    }

    /**
     * Update the data table of billing profiles.
     *
     * @param page - The page to display.
     * @param recordsPerPage - The amount of records to display on each page.
     * @param query - The search query.
     */
    searchBillingProfiles(page, recordsPerPage, query) {

        axios.post(`${constants.REACT_APP_HOST_BILLING_AND_INVOICING_URL}/billing/profile/search?recordsPerPage=${recordsPerPage}&page=${page}`, {
            orderBy: query.orderBy,
            orderByFields: query.orderByFields,
            conditionList: query.conditionList
        }, {
            headers: this.generateRequestHeaders()
        }).then(response => {
            this.setState(prevState => ({
                ...prevState,
                billingProfileList: response.data,
                billingProfileQuery: {
                    orderBy: query.orderBy,
                    orderByFields: query.orderByFields,
                    conditionList: query.conditionList
                }
            }));
        }).catch(error => {
            this.handleValidation(error);
        });
    }

    /**
     * Perform a search for all payment methods across all company owners within the company.
     */
    searchPaymentMethods() {

        let paymentMethodList = [];

        axios.post(`${constants.REACT_APP_HOST_API_URL}/company_owner/search`, {
            orderBy: 'ASC',
            orderByFields: ['id'],
            conditionList: [
                {
                    type: 'STRING',
                    logicalOperator: 'AND',
                    openBrackets: null,
                    closeBrackets: null,
                    fieldName: 'companyId',
                    operator: 'EQUALS',
                    fieldValue: this.props.match.params.companyId
                },
            ]
        },{
            headers: this.generateRequestHeaders()
        }).then(response => {

            let companyOwnerList = response.data.records;

            companyOwnerList.map((data, key) => {
                Object.keys(paymentTypes).map(key => {
                    axios.post(`${constants.REACT_APP_HOST_API_URL}/${paymentTypes[key]}/search`, {
                        orderBy: 'ASC',
                        orderByFields: ['id'],
                        conditionList: [
                            {
                                type: 'STRING',
                                logicalOperator: 'AND',
                                openBrackets: null,
                                closeBrackets: null,
                                fieldName: 'userId',
                                operator: 'EQUALS',
                                fieldValue: data.id
                            }
                        ]
                    }, {
                        headers: this.generateRequestHeaders()
                    }).then(response => {
                        response.data.records.map((data, key) => {

                            paymentMethodList.push(data);

                            this.setState(prevState => ({
                                ...prevState,
                                paymentMethodList: paymentMethodList,
                            }));

                            return null;

                        });
                    }).catch(error => {
                        this.handleValidation(error);
                    });

                    return null;
                });

                return null;
            });

        }).catch(error => {
            this.handleValidation(error);
        });
    }

    /**
     * Handle changes to the selected payment method. Parses the value of the selected payment method as JSON.
     *
     * @param event - The event container.
     */
    handleChangePaymentMethod(event) {

        event.persist();

        this.setState(prevState => ({
            ...prevState,
            [event.target.name]: JSON.parse(event.target.value),
        }));
    }

    /**
     * Render the component.
     *
     * @returns {*} - The company billing profiles component.
     */
    render() {

        return(
            <React.Fragment>

                <Alert validationList={this.state.validationList} validationType="primary" />

                <div className="card">
                    <div className="card-header">
                        <div className="row align-items-center">
                            <div className="col">
                                Billing Profiles
                            </div>
                            <div className="col text-right">
                                <div data-toggle="modal" data-target="#billing-profile" className="btn btn-primary btn-sm" onClick={() => this.initBillingProfile()}>
                                    <FontAwesomeIcon icon={['fas', 'plus']} className="fa-fw" /> Create Billing Profile
                                </div>
                            </div>
                        </div>
                    </div>
                    <Table columns={{firstName: 'Name', description: 'Description', autoBillingDefault: 'Default'}}
                           columnWidths={['25%', '50%', '25%']}
                           headerClass="c-pointer"
                           data={this.state.billingProfileList}
                           query={this.state.billingProfileQuery}
                           sortEnabled={true}
                           recordsEnabled={true}
                           paginationEnabled={true}
                           updateFunction={this.searchBillingProfiles}>
                        <tbody>
                        {this.state.billingProfileList.records.map((data, key) => {
                            return(
                                <tr key={key} onClick={() => this.editBillingProfile(data.id)} className="c-pointer">
                                    <td>
                                        <div className="">
                                            {data.firstName} {data.lastName}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="">
                                            {data.description}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="text-nowrap">
                                            <FontAwesomeIcon icon={['fas', 'circle']} className={`fa-fw small ${data.autoBillingDefault ? 'text-success' : 'text-secondary'}`} />
                                            <span className="ml-1">{data.autoBillingDefault ? 'Enabled' : 'Disabled'}</span>
                                        </div>
                                    </td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </Table>
                </div>

                <div className="modal fade" id="billing-profile" tabIndex="-1" role="dialog" aria-labelledby="billing-profile-label" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div className="modal-content shadow">
                            <form onSubmit={this.saveBillingProfile}>
                                <div className="modal-header bg-dark text-white">
                                    <h5 className="modal-title" id="billing-profile-label">
                                        {this.state.billingProfile['createDate'] == null &&
                                        <span className="">
                                            Create Billing Profile
                                        </span>
                                        }
                                        {this.state.billingProfile['createDate'] != null &&
                                        <span className="">
                                            Edit Billing Profile
                                        </span>
                                        }
                                    </h5>
                                    <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
                                        <FontAwesomeIcon icon={['fas', 'times']} className="fa-fw va-b mr-2" />
                                    </button>
                                </div>
                                <div className="modal-body">

                                    <Alert validationList={this.state.validationList} validationType="danger" />

                                    <FieldCheckbox id="autoBillingDefault" label="Default" model="billingProfile" fieldLabel="Use this billing profile as a default for auto-generated invoices" parent={this} value={this.state.billingProfile['autoBillingDefault']} />

                                    <FieldText id="description" label="Description" model="billingProfile" parent={this} value={this.state.billingProfile['description']} />

                                    <FieldLocale id="locale" label="Locale" model="billingProfile" parent={this} value={this.state.billingProfile['locale']} />

                                    <FieldText id="firstName" label="First Name" model="billingProfile" parent={this} value={this.state.billingProfile['firstName']} />

                                    <FieldText id="lastName" label="Last Name" model="billingProfile" parent={this} value={this.state.billingProfile['lastName']} />

                                    <FieldText id="email" type="email" label="Email" model="billingProfile" parent={this} value={this.state.billingProfile['email']} />

                                    <FieldAddress model="address" parent={this} value={this.state.address} suite={true} required={true} />

                                    <div className="form-group row">
                                        <label className="col-sm-3 col-form-label col-form-label-sm">
                                            Phones
                                        </label>
                                        <div className="col-sm-9">
                                            <FieldPhones phones={this.state.phoneNumberList} model="phoneNumberList" size="sm" parent={this} />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="col-sm-3 col-form-label col-form-label-sm">
                                            Payment Method
                                        </label>
                                        <div className="col-sm-9">

                                            {this.state.paymentMethodList.map((data, key) => {

                                                if(data.type !== 'TYPE_CASH') {
                                                    return (
                                                        <div key={key} className="list-group mb-2">
                                                            <div className="custom-control custom-radio list-group-item list-group-item-action c-pointer">
                                                                <input type="radio" name="paymentMethod" value={JSON.stringify(data)} id={key} checked={this.state.paymentMethod.id === data.id || false} onChange={this.handleChangePaymentMethod} className="custom-control-input"/>
                                                                <label className="custom-control-label pl-3 c-pointer" htmlFor={key}>
                                                                    <div className="row align-items-center">
                                                                        <div className="col-8">
                                                                            <div className="">
                                                                                {data.type === 'TYPE_BANK_ACCOUNT' &&
                                                                                <React.Fragment>
                                                                                    Bank Account
                                                                                </React.Fragment>
                                                                                }
                                                                                {data.type === 'TYPE_CREDIT_CARD' &&
                                                                                <React.Fragment>
                                                                                    <FormattedMessage id={"enum.creditCard.brand." + data.brand}/>
                                                                                </React.Fragment>
                                                                                }
                                                                            </div>
                                                                            <small className="mb-0 ml-md-0 small text-muted">
                                                                                {data.type === 'TYPE_BANK_ACCOUNT' &&
                                                                                <React.Fragment>
                                                                                    Account number ending in {data.last4}
                                                                                </React.Fragment>
                                                                                }
                                                                                {data.type === 'TYPE_CREDIT_CARD' &&
                                                                                <React.Fragment>
                                                                                    Card number ending in {data.last4}
                                                                                </React.Fragment>
                                                                                }
                                                                            </small>
                                                                        </div>
                                                                        <div className="col text-right">
                                                                            <div className="float-right mr-2">
                                                                                <CardBrandIcon paymentMethodType={data.type} brand={data.brand} customClasses="w-75"/>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    );
                                                }

                                                return null;

                                            })}

                                        </div>
                                    </div>

                                </div>
                                <div className="modal-footer bg-secondary rounded-bottom d-block">
                                    <div className="row">
                                        <div className="col-4">
                                            <button type="button" className="btn btn-outline-primary btn-lg" onClick={() => $("#billing-profile").modal("hide")}>Close</button>
                                        </div>
                                        <div className="col-8 text-right">

                                            {this.state.billingProfile['createDate'] != null &&
                                            <div className="btn btn-lg btn-primary ml-2" onClick={() => {$("#billing-profile").modal("hide"); $("#delete-billing-profile").modal("show");}}>
                                                Delete
                                            </div>
                                            }

                                            <ButtonSave />

                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <Modal id="delete-billing-profile" theme="danger" iconType="fas" iconName="exclamation-triangle" title="Delete Billing Profile"
                       body="Please confirm that you would like to delete this billing profile.">
                    <button type="button" className="btn btn-outline-danger btn-lg" data-dismiss="modal" onClick={() => {$("#billing-profile").modal("show")}}>
                        <FormattedMessage id="button.close" />
                    </button>
                    <button onClick={() => {this.deleteBillingProfile()}} className="btn btn-danger btn-lg" data-dismiss="modal">
                        Delete Billing Profile
                    </button>
                </Modal>

            </React.Fragment>
        )
    };
}

BillingProfiles.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(BillingProfiles);